import { EntityType } from '@frontend/common';
import { equipmentGroupRequest, productCategoryRequest, productGroupRequest, questionnaireRequest, userGroupRequest } from '@frontend/group/events';
import { IGroup } from '@frontend/group/types';
import { ENTITY_ICONS, iconByType } from '@frontend/icons';
import { getCorrectTranslation, useLocale } from '@frontend/lang';
import { ObjectBadge, ObjectBadgeProps } from '@frontend/rendering/badge';
import React from 'react';

export interface GroupBadgeProps extends ObjectBadgeProps<IGroup> {
    type: EntityType;
}
export const GroupBadge = (props: GroupBadgeProps) => {
    const { locale } = useLocale();
    if (!locale) return null;
    let request: (id: string) => string = userGroupRequest; //default is user group
    let type: string = 'user-groups';
    switch (props.type) {
        case EntityType.USER_GROUP:
            request = userGroupRequest;
            type = 'user-groups';
            break;
        case EntityType.EQUIPMENT_GROUP:
            request = equipmentGroupRequest;
            type = 'equipment-groups';
            break;
        case EntityType.PRODUCT_GROUP:
            request = productGroupRequest;
            type = 'product-groups';
            break;
        case EntityType.PRODUCT_CATEGORY:
            request = productCategoryRequest;
            type = 'product-categories';
            break;
        case EntityType.QUESTIONNAIRE:
            request = questionnaireRequest;
            type = 'questionnaires';
            break;
    }

    return (
        <ObjectBadge<IGroup>
            id={props.id}
            mapDisplayName={(gr: IGroup) => (gr.entity_type === EntityType.PRODUCT_CATEGORY ? getCorrectTranslation(locale, gr, 'name') : gr.name)}
            resolve={request}
            overWriteIcon={(gr) => (gr ? iconByType(gr.entity_type) : ENTITY_ICONS.GROUP)}
            navigateString={(object: IGroup) => `/accounts/${object.account_id}/${type}/${object.id}`}
            {...props}
        />
    );
};
